
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M23.375 0h-6.231a.625.625 0 100 1.25h4.732L9.719 13.523a.625.625 0 00.887.88L22.75 2.143v4.713a.625.625 0 101.25 0V.625A.625.625 0 0023.375 0z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M20.259 13.406a.625.625 0 00-.625.625v6.844a1.877 1.877 0 01-1.875 1.875H3.125a1.877 1.877 0 01-1.875-1.875V6.241a1.877 1.877 0 011.875-1.875h6.844a.625.625 0 100-1.25H3.125A3.129 3.129 0 000 6.241v14.634A3.129 3.129 0 003.125 24h14.634a3.129 3.129 0 003.125-3.125v-6.844a.625.625 0 00-.625-.625z","fill":"#E2E4EC"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"#fff"}})])])])
          )
        }
      }
    